<template>
  <v-app>
    <v-main class="grey lighten-2 d-flex align-center justify-center">
      <div class="d-flex justify-center">
        <v-card width="300px">
          <v-card-title
            ><v-icon class="red--text mr-2">$error</v-icon> 403 - Access Denied</v-card-title
          >
          <v-card-text>
            <p class="text-body-1">
              You do not have permission to view that page. If you need
              assistance you can contact customer support.
            </p>
            <help-block></help-block>
          </v-card-text>
        </v-card>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import HelpBlock from "../components/HelpBlock.vue";
export default {
  components: { HelpBlock }
};
</script>
